// removed by extract-text-webpack-plugin
module.exports = {"button":"ErrorOfflineScreen__button-2JYk6"};